import React from 'react';

import {ChevronLeftIcon} from '@/components/Icons';

import {ButtonRaw} from '../../../../components/Button';
import {getLocalizedStrings} from '../../../../services/localization/localizationService';
import appRouterService from '../../../../services/route/appRouterService';
import styles from './AdvancedDiagnosticIssueList.module.scss';

const AdvancedDiagnosticIssueList = ({issuesData}) => {
    const localizedStrings = getLocalizedStrings();

    const onClick = (nextStep) => {
        appRouterService.forwardToAdvancedDiagnosticScreen({screenName: nextStep});
    };

    return (
        <div className='mt-10 flex w-full flex-col ml:mt-8'>
            {issuesData?.map((issue, index) => {
                const {title, nextStep} = issue;
                const titleText = localizedStrings[title];

                if (!titleText) return null;

                return (
                    <div key={index} className='mb-2 w-full'>
                        <ButtonRaw onClick={() => onClick(nextStep)} className={styles.AdvancedDiagnosticIssueList}>
                            {titleText}
                            <div className='pl-5 rtl:pl-0 rtl:pr-5'>
                                <ChevronLeftIcon className='rotate-180 rtl:rotate-0' />
                            </div>
                        </ButtonRaw>
                    </div>
                );
            })}
        </div>
    );
};

export default AdvancedDiagnosticIssueList;
